import React, { useEffect, useState, useCallback } from "react"
import {useDispatch} from 'react-redux'
import { envAwarePost, capitalize } from "../../util/util";
import { useSelector } from "react-redux"
import { Link } from 'react-router-dom';
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import debounce from "lodash.debounce"
import classes from "./welcomeLinks.module.css"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Badge from 'react-bootstrap/Badge'
import InputGroup from 'react-bootstrap/InputGroup'
import {useWelcomeLinks} from './hooks'
import {
    updateWelcomeLinks,
    toggleWelcomeLinks
} from './settingsSlice'
import CenteredLoader from '../CenteredLoader/CenteredLoader'
import classesSettings from "./Settings.module.css"

const LinkTests = ({links})=>(
    <div className="d-flex mt-2">
        <span className="mr-2">Test links for each device:</span>
        <a 
            target="_blank" 
            href={links.web} 
            rel="noopener noreferrer"
        >
            Web
        </a>
        <span className="mx-2 text-muted">|</span>
        <a 
            target="_blank" 
            href={links.iOS} 
            rel="noopener noreferrer"
        >
            iOS
        </a>
        <span className="mx-2 text-muted">|</span>
        <a 
            target="_blank" 
            href={links.android} 
            rel="noopener noreferrer"
        >
            Android
        </a>
    </div>
)

const AccountLinks = ({accountType})=>{
    const dispatch = useDispatch()
    const [device,setDevice] = useState('web')
    const {[accountType]:links} = useWelcomeLinks()
    const linksDisabled = links.web.enabled === 0
    const [link,setLink] = useState(device === 'all' ? "" : links[device].welcome_link)
    const handleSave = ()=>{
        dispatch(updateWelcomeLinks({
            account_type:accountType,
            device,
            link
        }))
    }
    const handleToggle = e => {
        const enabled = Number(e.target.checked)
        dispatch(toggleWelcomeLinks({
            account_type:accountType,
            enabled
        }))
    }
    return (
        <div>
            <Form.Label>
              <strong>{capitalize(accountType)} Welcome Link:</strong>
            </Form.Label>
            <InputGroup>
                <Form.Control  
                    disabled={linksDisabled}
                    type="text" 
                    value={linksDisabled?"":link} 
                    placeholder="Welcome Link"
                    onChange={ (e) => {
                        setLink(e.target.value)
                    }}
                />
                <Form.Control  
                    onChange={e=>{ 
                        const newDevice = e.target.value
                        const newLink = newDevice === 'all' ? "" : links[newDevice].welcome_link
                        setDevice(newDevice) 
                        setLink(newLink)
                    }}
                    style={{maxWidth:'128px'}}
                    value={device}
                    as="select"
                >
                    <option value="web">Web</option>
                    <option value="iOS">iOS</option>
                    <option value="android">Android</option>
                    <option value="all">All Devices</option>
                </Form.Control>
                <InputGroup.Append>
                    <Button 
                        onClick={handleSave}
                        variant="outline-secondary"
                    >
                        Save
                    </Button>
                </InputGroup.Append>
            </InputGroup>
            <div className="d-flex align-items-center">
                <Form.Check 
                    label={`Enable ${accountType} welcome videos`}
                    id={`toggle-${accountType}-welcome-videos`}
                    checked={!linksDisabled}
                    type="switch"
                    onChange={handleToggle} 
                />
                <small className="ml-2">
                    <Badge pill variant={linksDisabled?'secondary':'success'}>
                       {linksDisabled?'OFF':'ON'}
                    </Badge>
                </small>
            </div>
            <LinkTests links={{
                web:links.web.welcome_link,
                iOS:links.iOS.welcome_link,
                android:links.android.welcome_link
            }}/>
        </div>
    )
}

function WelcomeLinks() {
    const accountType = useSelector(state => state.users.current_user.account_type);
    const {status} = useWelcomeLinks()
    return (
        <div className={`${classesSettings.cardWidth} shadow mb-5 bg-white border rounded px-5 py-3`}>
            <div className="flex-column">
                <h4>Welcome Videos</h4>
                <div className="mb-2">
                    These can now be edited in the new <Link to="/customization-dashboard">Customization Dashboard</Link>
                </div>
            </div>
        </div>

    )

}

export default WelcomeLinks;
